// M10-12722
import { useState } from "react";
import { Modal, Button, Checkbox } from "src/components";

interface PORemoveModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  onRemove: (selectedIds: any[]) => void;
}

export const PORemoveModalReusable = ({
  isOpen,
  onClose,
  data,
  onRemove
}: PORemoveModalProps) => {
  const [selectedRows, setSelectedRows] = useState<
    Map<string | number, any>
  >(new Map());
  const selectableData = data?.filter((item: any) => item?.is_po_generated === true) || [];
  const isAllSelected = selectableData.length > 0 && selectedRows.size === selectableData.length;
  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows(new Map());
    } else {
      const newMap = new Map();
      data
        ?.filter((item: any) => item?.is_po_generated === true)
        ?.forEach((item: any) => {
          newMap.set(item.invoice_product_order_product_id, item);
        });

      setSelectedRows(newMap);
    }
  };


  const handleRowSelect = (item: any) => {
    setSelectedRows((prev) => {
      const newMap = new Map(prev);

      if (newMap.has(item.invoice_product_order_product_id)) {
        newMap.delete(item.invoice_product_order_product_id);
      } else {
        newMap.set(item.invoice_product_order_product_id, item);
      }

      return newMap;
    });
  };


  const handleRemove = () => {
    onRemove(Array.from(selectedRows.values())); // ✅ full rows
    setSelectedRows(new Map());
    onClose();
  };


  const handleCancel = () => {
    setSelectedRows(new Map());
    onClose();
  };
  console.log(data, "data")
  return (
    <Modal isOpen={isOpen} isHeader={false} onCloseModal={handleCancel} title="PO Remove Details">
      <div className="p-6">
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Remove Purchase Orders</h2>
          <p className="text-sm text-gray-600 mt-1">
            Select the purchase orders you want to remove
          </p>
        </div>

        {selectedRows.size > 0 && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
            <p className="text-sm text-blue-800">
              <span className="font-semibold">{selectedRows.size}</span> item(s) selected
            </p>
          </div>
        )}

        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <div className="max-h-96 overflow-y-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3 text-left">
                    <div className="flex items-center gap-2">
                      <Checkbox checked={isAllSelected} onChange={handleSelectAll} />
                      <span className="text-xs font-medium text-gray-700">Select All</span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Item Code
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Order Code
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Item description
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Gross Amt.
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Inv. Scheme
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Discount %
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Cash Discount %
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Scheme Qty.
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    PO Number
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data?.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="px-4 py-8 text-center text-gray-500">
                      No purchase orders available
                    </td>
                  </tr>
                ) : (
                  data?.filter((item: any) => item?.is_po_generated == true)?.map((item: any) => (
                    <tr
                      key={item.invoice_product_order_product_id}
                      className={`hover:bg-gray-50 cursor-pointer ${selectedRows.has(item.invoice_product_order_product_id) ? 'bg-blue-50' : ''
                        }`}
                    // onClick={() => handleRowSelect(item.invoice_product_order_product_id)}
                    >
                      <td className="px-4 py-3">
                        <Checkbox
                          checked={selectedRows.has(item.invoice_product_order_product_id)}
                          onChange={() => handleRowSelect(item)}
                        />

                      </td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">
                        {item?.item_code}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.orderProduct?.order?.order_code}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.item_description}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{Number(item?.gross_amt).toFixed(2)}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.price_identifier}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{Number(item?.discount_perc).toFixed(2)}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.p_cash_discount_perc || "-"}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.free_qty || 0}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{item?.po_item?.purchaseOrder?.po_number || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <Button
            onClick={handleCancel}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemove}
            disabled={selectedRows.size === 0}
            className={`px-4 py-2 rounded-md ${selectedRows.size === 0
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-red-600 text-white hover:bg-red-700'
              }`}
          >
            Remove Selected ({selectedRows.size})
          </Button>
        </div>
      </div>
    </Modal >
  );
};
// M10-12722